import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from "@mui/material";
import { deleteDoc, doc, setDoc, updateDoc } from "firebase/firestore";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import { db } from "../../api/firebase";
import { nbfProduct } from "../../api/restApi";
import { productsData, setProducts } from "../../store/reducer/productsSlice";
import { useAppDispatch, useAppSelector } from "../../utils/hooks";
import MaterialTable from "../setting/Tables/MaterialTable";
import { UpdateRecipeDialog } from "./components/updateRecipe";

const INACTIVE_LOGUT_TIMER = 360000; // 360000ms = 1hour. You can change the time.

export const Products = ({ setAuth }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [openRecipeModal, setOpenRecipeModal] = useState(false);
  // const [tableData, setTableData] = useState(() => []);
  const [validationErrors, setValidationErrors] = useState({});
  const [recipe, setRecipe] = useState("");
  const collectionName = "product";
  const { products } = useAppSelector(productsData);
  const [productsArray, setProductsArray] = useState(() => products);
  const dispatch = useAppDispatch();
  console.log(products);
  const nbfProductInfo = async () => {
    let product = await nbfProduct();
    dispatch(setProducts(product));
  };

  // use effect to calculate and cost if recipe included
  useEffect(() => {
    const calculateCost = () => {
      // remove string from qunatity and size to make it number
      let tempProducts = products.map((item) => {
        if (
          item.recipe &&
          Array.isArray(item.recipe) &&
          item.recipe.length > 0
        ) {
          console.log(item);
          let cost = item.recipe.reduce((acc, curr) => {
            return acc + curr.lastPrice * parseFloat(curr.quantity);
          }, 0);
          if (item.recipeSize) {
            cost = Math.round(cost / parseFloat(item.recipeSize));
          }
          return {
            ...item,
            cost_price: cost,
            price_margin_percentage:
              Math.round(((parseFloat(item.price) - cost) / cost) * 100) + " %",
            fair_price_margin_percentage:
              Math.round(((parseFloat(item.fair_price) - cost) / cost) * 100) +
              " %",
          };
        } else {
          return item;
        }
      });
      setProductsArray(tempProducts);
    };
    calculateCost();
  }, [products]);

  const events = [
    "load",
    "mousemove",
    "mousedown",
    "click",
    "scroll",
    "keypress",
  ];

  const getNextProductId = useCallback(() => {
    if (!Array.isArray(products) || products.length === 0) {
      return "00001";
    }

    const numericIds = products
      .map((product) => {
        const rawId = product?.id;
        if (rawId === undefined || rawId === null) {
          return null;
        }

        const parsedId = parseInt(String(rawId), 10);
        return Number.isFinite(parsedId) ? parsedId : null;
      })
      .filter((id) => id !== null);

    const maxExistingId = numericIds.length > 0 ? Math.max(...numericIds) : 0;
    const nextIdNumber = maxExistingId + 1;

    return nextIdNumber.toString().padStart(5, "0");
  }, [products]);

  const handleCreateNewRow = async (values) => {
    try {
      const nextProductId = getNextProductId();
      await setDoc(doc(db, collectionName, nextProductId), values);
      // await addDoc(collection(db, collectionName), values);
      // console.log(response);
     
      nbfProductInfo();
      toast.success("Successfully add new item !", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    } catch (error) {
      // console.log(error);
      console.log(error);
      toast.error("Failed to add new item !", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  useEffect(() => {});
  const handleSaveRowEdits = async ({ exitEditingMode, row, values }) => {
    // if (!Object.keys(validationErrors).length) {
    console.log(values);
    try {
      let id = row.getValue("id").toString();
      // replaced all undefined values with ""
      Object.keys(values).forEach(function (key) {
        if (values[key] === undefined || values[key] === null) {
          values[key] = "";
        }
      });
      // console.log(values)
      // values.map((item) => {
      //   if (item === undefined) {
      //     item = "";
      //   }
      //   return
      // }
      // );
      await updateDoc(doc(db, collectionName, id), values);

      toast.success("Successfully update  item !", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      nbfProductInfo();
    } catch (error) {
      console.log(error);
      toast.error("Failed to  update  item!", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
    exitEditingMode(); //required to exit editing mode and close modal
    // }
  };

  const handleCancelRowEdits = () => {
    setValidationErrors({});
  };

  const handleDeleteRow = useCallback(async (row) => {
    const confirmed = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (confirmed.isConfirmed) {
      try {
        let id = row.getValue("id").toString();
        await deleteDoc(doc(db, collectionName, id));
        console.log(row.getValue("id"));
        toast.success("Successfully deleted  item !", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        nbfProductInfo();
      } catch (error) {
        console.log(error);
        toast.error("Failed to  delete  item!", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    } else {
      return;
    }
  });

  const getCommonEditTextFieldProps = useCallback(
    (cell) => {
      return {
        error: !!validationErrors[cell.id],
        helperText: validationErrors[cell.id],
        onBlur: (event) => {
          const isValid =
            cell.column.id === "email"
              ? validateEmail(event.target.value)
              : cell.column.id === "age"
              ? validateAge(+event.target.value)
              : validateRequired(event.target.value);
          if (!isValid) {
            //set validation error for cell if invalid
            setValidationErrors({
              ...validationErrors,
              [cell.id]: `${cell.column.columnDef.header} is required`,
            });
          } else {
            //remove validation error for cell if valid
            delete validationErrors[cell.id];
            setValidationErrors({
              ...validationErrors,
            });
          }
        },
      };
    },
    [validationErrors]
  );
  const RecipeButton = () => {
    return (
      <Button
        variant="contained"
        color="primary"
        onClick={() => setOpenRecipeModal(true)}
      >
        Update Recipe
      </Button>
    );
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "ID",
        enableColumnOrdering: false,
        enableEditing: false, //disable editing on this column
        enableSorting: false,
        size: 20,
      },
      {
        accessorKey: "barcode",
        header: "Barcode",
        size: 40,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
      },
      {
        accessorKey: "name_english",
        header: "Name Enlish",
        size: 40,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
      },
      {
        accessorKey: "price",
        header: "Supply Price",
        size: 10,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
      },
      {
        accessorKey: "bake1Price",
        header: "Bake1 Price",
        size: 10,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
      },
      {
        accessorKey: "fair_price",
        header: "Fair Price",
        size: 10,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
      },
      {
        accessorKey: "cost_price",
        header: "Cost Price",
        enableEditing: false, //disable editing on this column
        size: 10,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
      },
      {
        accessorKey: "price_margin_percentage",
        header: "Price Margin %",
        enableEditing: false, //disable editing on this column
        size: 10,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
      },
      {
        accessorKey: "fair_price_margin_percentage",
        header: "Fair Price Margin %",
        enableEditing: false, //disable editing on this column
        size: 20,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
      },
      {
        accessorKey: "recipe",
        header: "Recipe",
        size: 140,
        enableEditing: false, //disable editing on this column
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (!value || !Array.isArray(value)) {
            return null; // or handle the case when value is not an array
          }
          const dataArray = value.map(
            (item) => item.name + " (" + item.quantity + " " + item.unit + ")"
          );
          console.log(dataArray);
          return dataArray.join(", ");
        },

        editVariant: "select",
      },

      {
        accessorKey: "name_urdu",
        header: "Name Urdu",
        size: 140,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
      },
      {
        accessorKey: "type_english",
        header: "Type English",
        size: 140,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
      },
      {
        accessorKey: "type_urdu",
        header: "Type Urdu",
        size: 140,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
      },

      {
        accessorKey: "category_english",
        header: "Category English",
        size: 140,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
      },
      {
        accessorKey: "category_urdu",
        header: "Category Urdu",
        size: 140,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
      },
    ],
    [getCommonEditTextFieldProps]
  );
  return (
    <>
      <Stack spacing={4} marginX={4} mt={1}>
        <MaterialTable
          setCreateModalOpen={setCreateModalOpen}
          tableData={productsArray}
          handleSaveRowEdits={handleSaveRowEdits}
          handleCancelRowEdits={handleCancelRowEdits}
          handleDeleteRow={handleDeleteRow}
          columns={columns}
          csvFileName="products"
        >
          <RecipeButton />
        </MaterialTable>
      </Stack>

      <CreateNewAccountModal
        columns={columns}
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSubmit={handleCreateNewRow}
        recipe={recipe}
      />
      <UpdateRecipeDialog
        open={openRecipeModal}
        onClose={() => setOpenRecipeModal(false)}
      />
    </>
  );
};

//example of creating a mui dialog modal for creating new rows
export const CreateNewAccountModal = ({
  open,
  columns,
  onClose,
  onSubmit,
  recipe,
}) => {
  const [values, setValues] = useState({
    // NessSKU: "",
    // NessDesc: "",
    // WebstSKU: "",
  });

  const unitOptions = ["kg", "ltr", "packet", "piece"];

  // console.log(values)
  const handleSubmit = async () => {
    //put your validation logic here
    // console.log(values);

    onSubmit(values);
    onClose();
    console.log(values);
  };

  return (
    <Dialog open={open}>
      <DialogTitle textAlign="center">Create New Product</DialogTitle>
      <DialogContent>
        <form onSubmit={(e) => e.preventDefault()}>
          <Stack
            sx={{
              width: "100%",
              minWidth: { xs: "300px", sm: "360px", md: "400px" },
              gap: "1.5rem",
            }}
          >
            {columns.map((column) => {
              if (
                column.accessorKey !== "id" &&
                column.accessorKey !== "recipe" &&
                column.accessorKey !== "unit"
              ) {
                return (
                  <TextField
                    key={column.accessorKey}
                    label={column.header}
                    name={column.accessorKey}
                    onChange={(e) =>
                      setValues({ ...values, [e.target.name]: e.target.value })
                    }
                  />
                );
              } else if (column.accessorKey === "recipe") {
                return (
                  <Autocomplete
                    key={column.accessorKey}
                    options={recipe}
                    getOptionLabel={(option) => option}
                    value={values.recipe} // Change 'values.category_english' to 'values.recipe'
                    onChange={(e, newValue) =>
                      setValues({ ...values, recipe: newValue })
                    } // Change 'recipe_english' to 'recipe'
                    renderInput={(params) => (
                      <TextField {...params} label={column.header} />
                    )}
                  />
                );
              } else if (column.accessorKey === "unit") {
                return (
                  <Autocomplete
                    key={column.accessorKey}
                    options={unitOptions}
                    getOptionLabel={(option) => option}
                    value={values.unit} // Change 'values.category_english' to 'values.recipe'
                    onChange={(e, newValue) =>
                      setValues({ ...values, unit: newValue })
                    } // Change 'recipe_english' to 'recipe'
                    renderInput={(params) => (
                      <TextField {...params} label={column.header} />
                    )}
                  />
                );
              }
            })}
          </Stack>
        </form>
      </DialogContent>
      <DialogActions sx={{ p: "1.25rem" }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button color="secondary" onClick={handleSubmit} variant="contained">
          Create New Product
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const validateRequired = (value) => !!value.length;
const validateEmail = (email) =>
  !!email.length &&
  email
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
const validateAge = (age) => age >= 18 && age <= 50;
